<template>
  <div :class="glow ? 'subtitle-1' : ''">
    <info-block>
      {{ $t("common.coin-balance") }}:
      <coins-widget :amount="$store.state.coinSystem.account ? $store.state.coinSystem.account.balance : 0" />
    </info-block>
  </div>
</template>

<script>
import InfoBlock from "@/widgets/InfoBlock";
import CoinsWidget from "./CoinsWidget.vue";

export default {
  name: "CoinBalance",
  components: { InfoBlock, CoinsWidget },
  props: {
    glow: {
      type: Boolean,
      default: true
    }
  },
};
</script>